document.addEventListener('DOMContentLoaded', function() {
    
    document.querySelectorAll('.quiz-main-card.active').forEach(function(card) {
        setQuizCardData(card);
    });
    document.querySelectorAll('.quiz-main-card input[type="text"]').forEach(function(input) {
        input.addEventListener('input', function() {
            const value = this.value.trim();
            const card = this.closest('.quiz-main-card');
            changeQuizButtonStatus(card, value.length > 0);
        });
    });
    document.addEventListener('input', function(e) {
        if (e.target.matches('.quiz-main-card input[type="text"]')) {
            const value = e.target.value;
            const card = e.target.closest('.quiz-main-card');
            if (card) {
                changeQuizButtonStatus(card, value.length > 0);
            }
        }
    });
    document.addEventListener('change', function(e) {
        if (e.target.matches('.quiz-main-card input[type="radio"]')) {
            const card = e.target.closest('.quiz-main-card');
            const hasSelected = card.querySelectorAll('input[type="radio"]:checked').length > 0;
            card.querySelectorAll('label.is-selected').forEach(l => l.classList.remove('is-selected'));
            if (e.target.checked && e.target.nextElementSibling && e.target.nextElementSibling.tagName === 'LABEL') {
                e.target.nextElementSibling.classList.add('is-selected');
            }
            changeQuizButtonStatus(card, hasSelected);
        }
    });
    document.addEventListener('change', function(e) {
        const checkbox = e.target;
        if (!checkbox.matches('.quiz-main-card input[type="checkbox"]')) return;
        const card = checkbox.closest('.quiz-main-card');
        if (!card) return;
        const hasSelected = card.querySelectorAll('input[type="checkbox"]:checked').length > 0;
        const nextElem = checkbox.nextElementSibling;
        if (nextElem) {
            nextElem.classList.remove('is-selected');
        }
        changeQuizButtonStatus(card, hasSelected);
    });
    document.addEventListener('click', function(e) {
        if (e.target.closest('.quiz-main-button')) {
            const button = e.target.closest('.quiz-main-button');
            const cardIndex = button.dataset.cardIndex;
            const card = button.closest('.quiz-main-card');
            let input = null;
            let value = '';
            let name = '';
            if (button.classList.contains('quiz-main-button-next') && cardIndex - 1 === 1) {
                window._learnq = window._learnq || [];
                window._learnq.push([
                    "track",
                    "quiz_started",
                    { started_at: new Date().toISOString() }
                ]);
            };
            
            if (card.classList.contains('quiz-main-question-input')) {
                input = card.querySelector('input[type="text"]');
            } else if (card.classList.contains('quiz-main-question-radio')) {
                input = card.querySelector('input[type="radio"]:checked');
            }

            if (input) {
                value = input.value;
                name = input.name;
            }
            if (card.classList.contains('quiz-main-question-check')) {
                input = card.querySelectorAll('input[type="checkbox"]:checked');
                input.forEach(function(el, index) {
                    if (name === '') {
                        name = el.name;
                    }
                    if (index > 0) {
                        value += ';'
                    }
                    value += el.value;
                });
            }
            setQuizCookie(name, value);
            changeQuizShortcode(card.closest('.quiz-main-cards'), name, value);
            changeQuizCard(cardIndex);
        }
    });
    document.addEventListener('click', function(e) {
        const target = e.target.closest('.quiz-main-plan-add-button');
        if (!target) return;
        const button = target;
        const plan = button.closest('.quiz-main-plan');
        if (!plan) return;
        const variant = plan.querySelector('.quiz-main-plan-variant.changed');
        if (!variant) return;
        const items = [
            {
                id: variant.getAttribute('data-variant-id'),
                quantity: 1,
                selling_plan: variant.getAttribute('data-variant-subscription')
            }
        ];
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ items })
        })
        .then(res => res.json())
        .then(data => {
            const span = button.querySelector('span');
            if (span) span.innerHTML = 'Added to Cart';
            afterAddQuizPlanToCart(plan);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(err => console.error('Error:', err));
    });
    document.addEventListener('click', function(e) {
        const button = e.target.closest('.quiz-main-plan-button');
        if (!button) return;
        clearQuizData();
        window.location.href = '/cart';
    });
    document.addEventListener('click', function(e) {
        const button = e.target.closest('.quiz-main-plan-retake-button');
        if (!button) return;
        clearQuizData();
        document.querySelectorAll('.quiz-main-card').forEach(card => {
            card.querySelectorAll('input[type="radio"]:checked').forEach(radio => {
                radio.checked = false;
                radio.classList.remove('is-selected');
            });
            card.querySelectorAll('label.is-selected').forEach(label => {
                label.classList.remove('is-selected');
            });
            changeQuizButtonStatus(card, false);
        });
        const upsell = document.querySelector('.quiz-main-plan-upsell-block');
        document.querySelectorAll('.quiz-main-plan-variant.changed').forEach(variant => {
            const size = variant.getAttribute('data-variant-size');
            const subscription = upsell.getAttribute('data-subscription-' + size);
            const price = upsell.getAttribute('data-' + size + '-price');
            const discountElem = variant.querySelector('.discount');
            if (discountElem) discountElem.innerHTML = price;
            variant.setAttribute('data-variant-subscription', subscription);
        });
        document.querySelectorAll('.quiz-main-plan-sale').forEach(saleElem => {
            const numberElem = saleElem.querySelector('.number');
            if (numberElem) numberElem.innerHTML = '10.00';
        });
        changeQuizCard(1);
    });
    document.addEventListener('click', function(e) {
        const switchBtn = e.target.closest('.quiz-main-plan-switch');
        if (!switchBtn) return;
        const plan = switchBtn.closest('.quiz-main-plan');
        if (!plan) return;
        const price = plan.querySelector('.quiz-main-plan-variant.changed');
        if (!price) return;
        const defaultEl = price.querySelector('.default');
        const discountEl = price.querySelector('.discount');
        if (switchBtn.classList.contains('active')) {
            switchBtn.classList.remove('active');
            if (defaultEl) defaultEl.classList.remove('hide');
            if (discountEl) discountEl.classList.add('hide');
        } else {
            switchBtn.classList.add('active');
            if (discountEl) discountEl.classList.remove('hide');
            if (defaultEl) defaultEl.classList.add('hide');
        }
    });
    document.addEventListener('click', function(e) {
        const emailBtn = e.target.closest('.quiz-main-plans-email-button');
        if (!emailBtn) return;
        const email = document.getElementById('quiz_main_plans-email').value;
        const message = document.querySelector('.quiz-main-plans-email-message');
        let text = '';
        let classes = [];
        message.classList.remove('show', 'error', 'success');
        if (email === '') {
            text = 'Please, enter your email.';
            classes = ['show', 'error'];
        } else if (!isValidQuizEmail(email)) {
            text = 'Please, enter a valid email.';
            classes = ['show', 'error'];
        } else {
            text = 'Email sent successfully.';
            classes = ['show', 'success'];
        }
        message.textContent = text;
        message.classList.add(...classes);
        if (isValidQuizEmail(email)) {
            window._learnq.push(["identify", {
                "$email": email
            }]);
            
            emailBtn.closest('.quiz-main-plans-email-wrapper').classList.add('sended');
            setTimeout(() => {
                message.classList.remove('show');
            }, 5000);
        }
    });
});
function changeQuizButtonStatus(card, status) {
    const button = card.querySelector('.quiz-main-button-next');
    if (!button) return;
    if (status) {
        button.classList.remove('disabled');
    } else {
        button.classList.add('disabled');
    }
}
function changeQuizCard(cardIndex) {
    const newCard = document.querySelector('.quiz-main-card-' + cardIndex);
    const activeCard = document.querySelector('.quiz-main-card.active');
    if (activeCard) activeCard.classList.remove('active');
    if (newCard) {
        setQuizCardData(newCard);
        newCard.classList.add('active');
    } else {
        displayPlansCard();
    }
}
function setQuizCookie(name, value) {
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + '; path=/';
}
function getQuizCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^| )' + encodeURIComponent(name) + '=([^;]+)'));
    return match ? decodeURIComponent(match[1]) : null;
}
function deleteQuizCookie(name) {
  document.cookie = name + '=; Max-Age=0; path=/;';
}
function changeQuizShortcode(block, code, value) {
    if (!block) return;
    const elem = `<span data-shortcode="${code}">${value}</span>`;
    block.innerHTML = block.innerHTML.replaceAll('{$' + code + '$}', elem);
    block.querySelectorAll(`span[data-shortcode="${code}"]`).forEach(span => {
        span.textContent = value;
    });
}
function setQuizCardData(card) {
    if (card.classList.contains('quiz-main-question-input')) {
        const input = card.querySelector('input[type="text"]');
        if (!input) return;
        const name = input.name;
        const value = getQuizCookie(name);
        if (value) {
            input.value = value;
            changeQuizButtonStatus(card, true);
        }
    }
    if (card.classList.contains('quiz-main-question-radio')) {
        const firstInput = card.querySelector('input');
        if (!firstInput) return;
        const name = firstInput.name;
        const value = getQuizCookie(name);
        if (value) {
            const input = card.querySelector(`input[value="${CSS.escape(value)}"]`);
            if (input) {
                input.checked = true;
                if (input.nextElementSibling?.tagName === 'LABEL') {
                    input.nextElementSibling.classList.add('is-selected');
                }
                changeQuizButtonStatus(card, true);
            }
        }
    }
    if (card.classList.contains('quiz-main-question-check')) {
        const firstInput = card.querySelector('input');
        if (!firstInput) return;
        const name = firstInput.name;
        const value = getQuizCookie(name);
        if (value) {
            const valueArr = value.split(';');
            valueArr.forEach(function(value) {
                const input = card.querySelector(`input[value="${CSS.escape(value)}"]`);
                if (input) {
                    input.checked = true;
                    if (input.nextElementSibling?.tagName === 'LABEL') {
                        input.nextElementSibling.classList.add('is-selected');
                    }
                    changeQuizButtonStatus(card, true);
                }
            });
        }
    }
}
function findKeyByValue(obj, value) {
  for (let key of Object.keys(obj)) {
    let item = obj[key];
    if (Array.isArray(item)) {
      if (item.includes(value)) {
        return { key: key, match: 1 };
      }
      if (item.some(v => typeof v === 'string' && v.includes(value))) {
        return { key: key, match: 0.5 };
      }
    }
  }
  return undefined;
}
function filterQuizPlans() {
    let planRating = {
        mobility: 0,
        skin__coat: 0,
        digestive: 0,
        calming: 0,
        vitality: 0
    };
    let radios = document.querySelectorAll('.quiz-main-question-radio');
    radios.forEach(function(el) {
        let input = el.querySelector('input');
        if (!input) return;
        let cookieKey = input.getAttribute('name');
        let cookieValue = getQuizCookie(cookieKey);
        let filter = findKeyByValue(quiz_logics, cookieValue);
        if (filter) {
            planRating[filter.key] += filter.match;
        }
    });
    let checks = document.querySelectorAll('.quiz-main-question-check');
    checks.forEach(function(el) {
        let input = el.querySelector('input');
        if (!input) return;
        let cookieKey = input.getAttribute('name');
        let cookieValue = getQuizCookie(cookieKey);
        let cookieValueArr = cookieValue.split(';');
        cookieValueArr.forEach(function(value) {
            let filter = findKeyByValue(quiz_logics, value);
            if (filter) {
                planRating[filter.key] += filter.match;
            }
        });
    });
    let sortedEntries = Object.entries(planRating)
        .map(function(pair) {
            return [pair[0], Math.floor(pair[1])];
        })
        .sort(function(a, b) {
            return b[1] - a[1];
        });
    let sorted = Object.fromEntries(sortedEntries);
    return sorted;
}
function displayPlansCard() {
    sendKlaviyoCompleted();
    let planCard = document.querySelector('.quiz-main-plan-block');
    let filterPlans = filterQuizPlans();
    let keys = Object.keys(filterPlans).slice(0, 3);
    let size = getQuizCookie('size');
    document.querySelectorAll('.quiz-main-plan.active').forEach(el => {
        el.classList.remove('active', 'added', 'sale-large', 'sale-medium');
        el.className = el.className
            .split(' ')
            .filter(c => !/^quiz-main-plan-\d+$/.test(c))
            .join(' ');
        el.querySelector('.quiz-main-plan-variant.changed').classList.remove('changed');
        delete el.dataset.position;
    });
    
    keys.forEach(function(key, index) {
        let el = document.querySelector('.quiz-main-plan[data-plan-name="' + key + '"]');
        if (el) {
            el.classList.add('active', 'quiz-main-plan-' + (index + 1));
            el.dataset.position = index + 1;
            el.querySelector('.quiz-main-plan-variant[data-variant-size="' + size + '"]').classList.add('changed');
        }
    });
    setQuizSubscribeId();
    setQuizSubscribe();
    planCard.classList.add('active');
    changeQuizSaleMessage();
}
function changeQuizSaleMessage() {
    let sale = 0;
    const dentalChews = document.querySelector('.quiz-main-plans-sale .dental-chews')?.innerHTML || 0;
    const delivery = document.querySelector('.quiz-main-plans-sale .delivery')?.innerHTML || 0;
    document.querySelectorAll('.quiz-main-plan.added').forEach(plan => {
        const planSale = plan.querySelector('.quiz-main-plan-sale .number')?.innerHTML || 0;
        sale += Number(planSale);
    });
    sale += Number(dentalChews) + Number(delivery);
    const saleOutput = document.querySelector('.quiz-main-plans-sale .sale');
    if (saleOutput) {
        saleOutput.textContent = sale.toFixed(2);
    }
}
function clearQuizData() {
    document.querySelectorAll('.quiz-main-question-block').forEach(block => {
        const input = block.querySelector('input');
        if (input) {
            const name = input.getAttribute('name');
            deleteQuizCookie(name);
        }
    });
}
function afterAddQuizPlanToCart(plan) {
    const card = plan.closest('.quiz-main-plan-block');
    let quantity = Number(card.getAttribute('data-quantity')) || 0;
    let sizeElem = plan.querySelector('.quiz-main-plan-variant.changed');
    let size = sizeElem ? sizeElem.getAttribute('data-variant-size') : null;
    let price = 0;
    card.setAttribute('data-quantity', quantity + 1);
    plan.classList.add('added');
    document.querySelectorAll('.quiz-main-plan.active').forEach(activePlan => {
        if (!activePlan.classList.contains('added')) {
            const variant = activePlan.querySelector('.quiz-main-plan-variant.changed');
            if (!variant) return;
            if (activePlan.classList.contains('sale-medium')) {
                activePlan.classList.remove('sale-medium');
                activePlan.classList.add('sale-large');
                const upsell = card.querySelector('.quiz-main-plan-upsell-3');
                const subscription = variant.getAttribute('data-variant-subscription-3');
                price = Number(upsell.getAttribute('data-' + size + '-price'));
                activePlan.classList.add('sale-medium');
                variant.setAttribute('data-variant-subscription', subscription);
                variant.querySelector('.discount').innerHTML = price.toFixed(2);
            } else {
                const upsell = card.querySelector('.quiz-main-plan-upsell-2');
                const subscription = variant.getAttribute('data-variant-subscription-2');
                price = Number(upsell.getAttribute('data-' + size + '-price'));
                activePlan.classList.add('sale-medium');
                variant.setAttribute('data-variant-subscription', subscription);
                variant.querySelector('.discount').innerHTML = price.toFixed(2);
            }
            const priceDefault = Number(variant.querySelector('.default').innerHTML);
            let sale = (priceDefault - price) * 30;
            activePlan.querySelector('.quiz-main-plan-sale .number').innerHTML = sale.toFixed(2);
        }
    });
    changeQuizSaleMessage();
}
function isValidQuizEmail(email) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
}
function setQuizSubscribeId() {
    const variants = document.querySelectorAll('.quiz-main-plan-variant.changed');
    variants.forEach(item => {
        let id = item.getAttribute('data-variant-id');
        fetch(`/variants/${id}.js`)
        .then(r => r.json())
        .then(variant => {
            if (variant.selling_plan_allocations) {
                variant.selling_plan_allocations.forEach((plan, idx) => {
                    item.setAttribute('data-variant-subscription-' + (idx + 1), plan.selling_plan_id);
                    if (idx === 0) {
                        item.setAttribute('data-variant-subscription', plan.selling_plan_id);
                    }
                });
            }
        });
    });
}
function sendKlaviyoCompleted() {
    let data = {};
    
    let textInputs = document.querySelectorAll('.quiz-main-question-input');
    textInputs.forEach(function(el) {
        let input = el.querySelector('input');
        if (!input) return;
        let cookieKey = input.getAttribute('name');
        let cookieValue = getQuizCookie(cookieKey);
        data[cookieKey] = cookieValue;
    });
    let radios = document.querySelectorAll('.quiz-main-question-radio');
    radios.forEach(function(el) {
        let input = el.querySelector('input');
        if (!input) return;
        let cookieKey = input.getAttribute('name');
        let cookieValue = getQuizCookie(cookieKey);
        data[cookieKey] = el.querySelector('input[name="' + cookieKey + '"][value="' + cookieValue + '"]').nextElementSibling.querySelector('span').textContent;
    });
    let checks = document.querySelectorAll('.quiz-main-question-check');
    checks.forEach(function(el) {
        let input = el.querySelector('input');
        if (!input) return;
        let cookieKey = input.getAttribute('name');
        let cookieValue = getQuizCookie(cookieKey);
        let cookieValueArr = cookieValue.split(';');
        let checksString = '';
        cookieValueArr.forEach(function(value) {
            if (checksString !== '') {
                checksString += ', ';
            }
            checksString += el.querySelector('input[name="' + cookieKey + '"][value="' + value + '"]').nextElementSibling.querySelector('span').textContent;
        });
        data[cookieKey] = checksString;
    });
    window._learnq = window._learnq || [];
    window._learnq.push([
        "track",
        "quiz_completed",
        data
    ]);
}
async function getQuizCart() {
    const result = await fetch('/cart.js');
    return await result.json();
}
async function setQuizSubscribe() {
    const cart = await getQuizCart();
    if (cart.item_count === 0) return;
    let cartItems = [];
    cart.items.forEach(item => {
        const plan = document.querySelector('.quiz-main-plan-variant.changed[data-variant-id="' + item.id + '"]');
        if (plan) {
            if (item.selling_plan_allocation) {
                cartItems.push(plan);
            } else {
                plan.closest('.quiz-main-plan').classList.add('added');
            }
        }
    });
    cartItems.forEach(item => {
        const plan = item.closest('.quiz-main-plan');
        afterAddQuizPlanToCart(plan);
    });
}
